import script from "./FaIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./FaIcon.vue?vue&type=script&setup=true&lang=js"

import "./FaIcon.vue?vue&type=style&index=0&id=74d091d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74d091d6"]])

export default __exports__